module.exports = __webpack_public_path__ + "static/media/prk.55e3b667.svg";